import { render, staticRenderFns } from "./LoadObjectsAdd.vue?vue&type=template&id=60146c26&scoped=true"
import script from "./LoadObjectsAdd.vue?vue&type=script&lang=js"
export * from "./LoadObjectsAdd.vue?vue&type=script&lang=js"
import style0 from "./LoadObjectsAdd.vue?vue&type=style&index=0&id=60146c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60146c26",
  null
  
)

export default component.exports